import { useT } from '_metronic/i18n/Metronici18n'
import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { CargoClienteModal } from '../modal/CargoClienteModal'

export const CargoClienteListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()
  const openAddCargo = () => {
    showModal({
      title: 'Cargo',
      content: <CargoClienteModal />,
      size: ModalSize.Medium,
    })
  }

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openAddCargo}>
      {t('common.add')}
    </Button>
  )
}
